import { useaxios } from "../../../utils/useaxios";
export default (category_id, barcode) => initDispatch => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('report/jard.php', { category_id, barcode }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            initDispatch({ type: 'setstok', payload: { stok: res.data, total_stock_price: res.total_stock_price } });
        }
        // setloading(false);
    });
}